import { EndpointWithoutRequest, Http } from "Application/Helpers/BaseEndpoint";
import { runInAction } from "mobx";
import { YourPurchaseViewModel } from "../YourPurchaseViewModel";
import { PurchaseStagesModel } from "../PurchaseStages/PurchaseStagesModel";
import { AppUrls } from "AppUrls";

class Response {
    public plotId: string = "";
    public plotNumber: string = "";
    public salesProgressCoinsItems: GetSalesStagesAdminItemResponse[] = [];
}
class GetSalesStagesAdminItemResponse {
    public id: string | null = "";
    public sequence: string = "";
    public stageCode: string = "";
    public description: string = "";
    public title: string = "";
    public isVisible: boolean = false;
    public imageUrl: string = "";
}

export class GETYourPurchaseEndpoint extends EndpointWithoutRequest<Response> {
    private viewModel: YourPurchaseViewModel;
    constructor(viewModel: YourPurchaseViewModel) {
        super();
        this.verb(Http.Get);
        this.path(AppUrls.Server.SalesStageAdmin.GetSalesStagesAdmin);
        this.viewModel = viewModel;
    }

    public async HandleResponseAsync(response: Response): Promise<any> {
        this.viewModel.setValue("plotNumber", response.plotNumber);
        this.viewModel.setValue("plotId", response.plotId);
        runInAction(() => {
            let responseData: PurchaseStagesModel[] = [];
            for (const item of response.salesProgressCoinsItems) {
                let m = new PurchaseStagesModel();
                m.id = item.id;
                m.sequence = item.sequence;
                m.stageCode = item.stageCode;
                m.description = item.description;
                m.isVisible = item.isVisible;
                m.title = item.title;
                m.imageUrl = item.imageUrl;
                responseData.push(m);
            }
            this.viewModel.model.stagesModels.replace(responseData);
        });
        return {};
    }
}
